const Button = ({
  children,
  onClick,
  disabled,
  fixed,
  type = "button",
  className = "",
}) => {
  const baseClasses = `
    bg-green text-white border-none py-4 px-8 rounded-[88px] text-base font-medium cursor-pointer
    transition-all duration-200 w-full min-h-[52px] md:min-h-[58px] flex items-center justify-center
    disabled:opacity-0 disabled:translate-y-5 disabled:pointer-events-none
    enabled:opacity-100 enabled:translate-y-0
    hover:enabled:-translate-y-0.5 active:enabled:translate-y-0
  `;

  const transitionClasses = disabled
    ? "transition-all duration-600 ease-[cubic-bezier(0.25,1.6,0.5,1)]"
    : "transition-all duration-400 ease-[cubic-bezier(0.25,1.6,0.5,1)]";

  const circleIcon = `${window.template_root}/src/public/img/next-circle.svg;`;

  if (fixed) {
    return (
      <div className="fixed bottom-2 md:bottom-[15px] left-1/2 -translate-x-1/2 w-[calc(100%-1rem)] md:w-[calc(100%-1.4rem)] max-w-[520px] md:max-w-[560px] p-4 pt-8 z-50 flex justify-center items-end bg-gradient-to-b from-[#E7F1ED]/0 to-[#E7F1ED] to-[80.67%] rounded-b-[18px] md:rounded-b-[22px]">
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className={`${baseClasses} ${transitionClasses} ${className}`}
        >
          {children}
          <span
            className="inline-block w-[18px] h-[18px] bg-[image:var(--icon)] bg-contain bg-no-repeat ml-1.5 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5"
            style={{ "--icon": `url('${circleIcon}')` }}
          />
        </button>
      </div>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${transitionClasses} ${className}`}
    >
      {children}
      <span
        className="inline-block w-[18px] h-[18px] bg-[image:var(--icon)] bg-contain bg-no-repeat ml-1.5 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5"
        style={{ "--icon": `url('${circleIcon}')` }}
      />
    </button>
  );
};

export default Button;
